import React from 'react'
import { useTranslation } from 'react-i18next'

import { STARS_COUNT } from 'components/Review/constants'

import starIcon from 'assets/images/sprite/star-gold-bright.svg'

import { StyledTrustBadge as S } from './TrustBadge.styles'

export const TrustBadge: React.FC = () => {
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Rating>
        {Array.from({ length: STARS_COUNT }, (_, index) => (
          <S.Star
            key={`landing-wellness-star-${index}`}
            svg={starIcon}
            width={20}
            height={20}
          />
        ))}
      </S.Rating>

      <S.Text>{t('onboarding.landingWellness.trustedByMuslim')}</S.Text>
    </S.Wrapper>
  )
}
